// A task's full page was /work/tasks/:taskId/details (the legacy detail page, retired 29 Oct 2026, SEN-435):
// the task is a Poiesis record now and its full page is the Poiesis task page (./TaskPage). Old links (mails,
// bookmarks, the Work page's own button until then) keep working, query string kept.
import { Navigate, useLocation, useParams } from 'react-router-dom'
import { taskPagePath } from './taskPagePath'

export function LegacyTaskDetailsRedirect() {
  const { taskId } = useParams<{ taskId: string }>()
  const { search } = useLocation()
  return <Navigate to={`${taskPagePath(taskId ?? '')}${search}`} replace />
}
